import CommonService from '../../../../services/commonService';
import React from 'react';

function MyCard(props) {
  console.log('Card is---------', props.data);
  return (
    <div key={props.key} className={'my-cards-main-item kupos-card txn-item'}>
      <div className={'card-item'}>
        <img
          style={{ height: 16 }}
          src={
            props.cardTypes[props.val[2]] == 'americanexpress'
              ? '/images/cards/americanexpress.png'
              : props.cardTypes[props.val[2]] == 'diners'
              ? '/images/cards/diners.png'
              : props.cardTypes[props.val[2]] == 'magna'
              ? '/images/cards/magna.png'
              : props.cardTypes[props.val[2]] == 'mastercard'
              ? '/images/cards/mastercard.png'
              : props.cardTypes[props.val[2]] == 'redcompra'
              ? '/images/cards/redcompra.png'
              : '/images/cards/visa.png'
          }
        />
        <div className="two-items">
          <span className="font11 bold-text">{props.t('PROFILE.CARD_NUMBER')}</span>
          <span className="font10" style={{ marginTop: 5 }}>
            {props.val[0].replace(/X/gi, '*').substring(8, 12) +
              ' ' +
              props.val[0].substring(12, 16)}
          </span>
        </div>
      </div>
      <div className="cards-vl"></div>
      <div className="name-action">
        <div className="two-items">
          <span className="font11 bold-text">{props.t('HOME.NAME')}</span>
          <span className="font10">
            {CommonService.capitalize(
              props.data &&
                props.data.loginData &&
                props.data.loginData.name &&
                props.data.loginData.last_name &&
                props.data.loginData.name + ' ' + props.data.loginData.last_name,
            )}
          </span>
        </div>
        <div className="action-buttons">
          <img
            style={{ marginRigh: 20 }}
            src={'/images/delete_card.svg'}
            onClick={() => {
              props.setShowDeleteCard(true);
              props.setSelectedItemForDeletion(props.val);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default MyCard;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/components/MyCard.js